import { skipToken, useQuery } from "@tanstack/react-query";
import { baseApi } from "./baseApi";

export const usePostMarketPlaceFilterAuthors = (
  formData: any,
  page?: string,
  size?: string,
) => {
  return useQuery({
    queryKey: ["market-place-filter-authous", page, size],
    queryFn:
      !page || !size || !formData
        ? skipToken
        : async () => {
            const response = await baseApi.post(
              `/marketplace_filter_authors?page=${page}&size=${size}`,
              formData, // Send FormData directly
              {
                headers: {
                  "Content-Type": "multipart/form-data", // Ensure it's treated correctly
                },
              },
            );
            return response;
          },
    retry: 0,
    staleTime: 3000,
  });
};

export const usePostMarketplaceFilterStrategies = (
  filters: any,
  page?: string,
  size?: string,
) => {
  return useQuery({
    queryKey: ["marketplace-filter-strategies", page, size, filters],
    queryFn:
      !page || !size || !filters
        ? skipToken
        : async () => {
            const formData = new FormData();
            Object.entries(filters).forEach(([key, value]) => {
              if (value !== undefined && value !== null)
                formData.append(key, value as any);
            });
            const response = await baseApi.post(
              `/marketplace_filter_strategies?page=${page}&size=${size}`,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              },
            );
            return response;
          },
  });
};

export const useGetMarketplaceLongShortDominance = () => {
  return useQuery({
    queryKey: ["marketplace_long_short_dominance"],
    queryFn: async () => {
      const response = await baseApi.get("/marketplace_long_short_dominance");
      return response.data;
    },
  });
};

export const useGetMarketplaceEntryExitDominance = () => {
  return useQuery({
    queryKey: ["marketplace_entry_exit_dominance"],
    queryFn: async () => {
      const response = await baseApi.get("/marketplace_entry_exit_dominance");
      return response.data;
    },
  });
};
export const useGetMarketplaceRecentTrades = () => {
  return useQuery({
    queryKey: ["marketplace_recent_trades"],
    queryFn: async () => {
      const response = await baseApi.get("/marketplace_recent_trades");
      return response.data;
    },
    refetchInterval: 60000,
  });
};
